// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CJ7r","top":"styles_top__1t5vG","left":"styles_left__3qOf6","description":"styles_description__1bVOA"};